<template>
  <div class="notification_info_popup">
    <div class="notification_info_modal" :class="activePopup ? 'active' : ''">
      <div class="notification_info_modal_header">
        <span class="notification_info_close"><i aria-hidden="true" class="fa fa-times-circle" @click="infoPopupClosedMethod"></i></span>
      </div>
      <div class="notification_info_modal_body">
        <div class="g_notification_page_wrp connections_section">
          <div class="g_notification_heading_wrp">
            <div class="row">
              <div class="col">
                <h2 class="g_notification_heading">{{ this.name }}</h2>
              </div>
              <div class="col-auto ml-auto">
                <button class="btn btn-primary read_all" @click="readAllNotificationMethod">Read All</button>
              </div>
            </div>
            <div class="row mt-3">
              <div class="col text-right">
                <div class="switch_for_status_button">
                  <div class="onoffswitch">
                    <input type="checkbox" name="onoffswitch" id="statusChangeOfRead" class="onoffswitch-checkbox"
                      v-model="isReadState" :checked="isReadState">
                    <label for="statusChangeOfRead" class="onoffswitch-label" @click="isReadChangeMethod">
                      <span class="onoffswitch-inner"></span>
                      <span class="onoffswitch-switch"></span>
                    </label>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <table>
            <tbody v-if="getGlobalNotificationData">
              <template v-if="this.name == 'reminders'">
                <template v-if="getGlobalNotificationDataResults.reminders.length > 0">
                  <tr v-for="item in getGlobalNotificationDataResults.reminders" :key="item.id">
                    <template v-if="item.is_read">
                      <td width="100%" class="gray_out">
                        <h2 class="notifiaction_title" v-html="item.notification"></h2>
                        <div class="notification_date">{{ item.created_at | LocalDateFormat }}
                          {{ item.created_at | LocalTimeFormat }}</div>
                      </td>
                    </template>
                    <template v-else>
                      <td width="70%">
                        <h2 class="notifiaction_title" v-html="item.notification"></h2>
                        <div class="notification_date">{{ item.created_at | LocalDateFormat }}
                          {{ item.created_at | LocalTimeFormat }}</div>
                      </td>
                      <td width="30%">
                        <button class="btn btn-danger dismiss-notification"
                          @click="readNotificationByIdMethod(item.id)">Read</button>
                      </td>
                    </template>
                  </tr>
                </template>
                <template v-else>
                  <tr>
                    <td colspan="2">You don't have any reminders yet.</td>
                  </tr>
                </template>
              </template>
              <template v-else-if="name == 'connections'">
                <template v-if="getGlobalNotificationDataResults.connection_request.length > 0">
                  <tr v-for="item in getGlobalNotificationDataResults.connection_request" :key="item.id">
                    <template v-if="item.is_read">
                      <td width="100%" class="gray_out">
                        <h2 class="notifiaction_title" v-html="item.notification"></h2>
                        <div class="notification_date">{{ item.created_at | LocalDateFormat }}
                          {{ item.created_at | LocalTimeFormat }}</div>
                      </td>
                    </template>
                    <template v-else>
                      <td width="70%">
                        <h2 class="notifiaction_title" v-html="item.notification"></h2>
                        <div class="notification_date">{{ item.created_at | LocalDateFormat }}
                          {{ item.created_at | LocalTimeFormat }}</div>
                      </td>
                      <td width="30%">
                        <button class="btn btn-danger dismiss-notification"
                          @click="readNotificationByIdOfReqMethod(item.id)">View Request</button>
                      </td>
                    </template>
                  </tr>
                </template>
                <template v-else>
                  <tr>
                    <td colspan="2">You don't have any connection request notification yet.</td>
                  </tr>
                </template>
              </template>
              <template v-else-if="this.name == 'announcements'">
                <template v-if="getGlobalNotificationDataResults.announcement.length > 0">
                  <tr v-for="item in getGlobalNotificationDataResults.announcement" :key="item.id">
                    <template v-if="item.is_read">
                      <td width="100%" class="gray_out">
                        <h2 class="notifiaction_title" v-html="item.notification"></h2>
                        <div class="notification_date">{{ item.created_at | LocalDateFormat }}
                          {{ item.created_at | LocalTimeFormat }}</div>
                      </td>
                    </template>
                    <template v-else>
                      <td width="70%">
                        <h2 class="notifiaction_title" v-html="item.notification"></h2>
                        <div class="notification_date">{{ item.created_at | LocalDateFormat }}
                          {{ item.created_at | LocalTimeFormat }}</div>
                      </td>
                      <td width="30%">
                        <button class="btn btn-danger dismiss-notification"
                          @click="readNotificationByIdMethod(item.id)">Read</button>
                      </td>
                    </template>
                  </tr>
                </template>
                <template v-else>
                  <tr>
                    <td colspan="2">You don't have any announcements notification yet.</td>
                  </tr>
                </template>
              </template>
              <template v-else>
                <template v-if="getGlobalNotificationDataResults.reminders.length > 0">
                  <tr v-for="item in getGlobalNotificationDataResults.reminders" :key="item.id">
                    <template v-if="item.is_read">
                      <td width="100%" class="gray_out">
                        <h2 class="notifiaction_title" v-html="item.notification"></h2>
                        <div class="notification_date">{{ item.created_at | LocalDateFormat }}
                          {{ item.created_at | LocalTimeFormat }}</div>
                      </td>
                    </template>
                    <template v-else>
                      <td width="70%">
                        <h2 class="notifiaction_title" v-html="item.notification"></h2>
                        <div class="notification_date">{{ item.created_at | LocalDateFormat }}
                          {{ item.created_at | LocalTimeFormat }}</div>
                      </td>
                      <td width="30%">
                        <button class="btn btn-danger dismiss-notification"
                          @click="readNotificationByIdMethod(item.id)">Read</button>
                      </td>
                    </template>
                  </tr>
                </template>
                <template v-else>
                  <tr>
                    <td colspan="2">You don't have any reminders yet.</td>
                  </tr>
                </template>
              </template>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
/*eslint-disable */;
import { mapGetters } from 'vuex';
import { bus } from '@/main';
import toast from '@/services/toast';
export default {
  name: 'notification-info-popup',
  props: ['name'],
  data() {
    return {
      getGlobalNotificationData: null,
      getGlobalNotificationDataResults: [],
      isReadState: false,
      activePopup:false,
      filterName:''
    }
  },
  computed: {
    ...mapGetters([
      'getGlobalNotificationGetters'
    ]),
    getGlobalNotificationInfo() {
      this.getGlobalNotificationData = this.$store.getters.getGlobalNotificationGetters.data;
      return;
    },
    setInitialStates() {
      if (this.getGlobalNotificationData) {
        this.getGlobalNotificationDataResults = this.getGlobalNotificationData.result;
      }
    }
  },
  mounted() {
    this.getGlobalNotificationInfo;
    this.setInitialStates;
    setTimeout(() => {
      document.body.classList.add('body_right_scroll_remove');
      this.activePopup = true;
    }, 10);
  },
  methods: {
    infoPopupClosedMethod(){
     document.body.classList.remove('body_right_scroll_remove');
     bus.$emit('infoPopupStateBus', false);
    },
    readNotificationByIdOfReqMethod(itemId) {
      let data = {
        id: itemId,
        is_read: 'True'
      }
      this.$store.dispatch('readNotificationByIdAction', data).then((res) => {
          this.$router.push({ name: 'saChatRequestList' });
      })
    },
    readNotificationByIdMethod(itemId) {
      let data = {
        id: itemId,
        is_read: 'True'
      }
      this.$store.dispatch('readNotificationByIdAction', data).then((res) => {
        this.$store.dispatch('getGlobalNotificationMethod', { flag: 'False' });
        toast.success('Notification is marked as read!');
      })
    },
    isReadChangeMethod() {
      if (this.isReadState) {
        this.$store.dispatch('getGlobalNotificationMethod', { flag: 'False' });
      } else {
        this.$store.dispatch('getGlobalNotificationIsReadListMethod').then((res) => {
          this.getGlobalNotificationData = res.data.data;
          this.getGlobalNotificationDataResults = this.getGlobalNotificationData.result;
        })
      }
    },
    readAllNotificationMethod() {
      if(this.name == 'reminders'){
        this.filterName = 'reminders';
      }else if(this.name == 'connections'){
        this.filterName = 'connection_request';   
      }else if(this.name == 'announcements'){
        this.filterName = 'announcement';  
      }
      this.$store.dispatch('patchGlobalNotificationReadMethod', {flag:this.filterName}).then((res) => {
        this.$store.dispatch('getGlobalNotificationMethod', { flag: 'False' })
        toast.success(res.data);
      }).catch((err) => {
        toast.error(err.data.msg);
      })
    }
  },
  watch: {
    getGlobalNotificationInfo() {
      return this.$store.getters.getGlobalNotificationGetters;
    },
    setInitialStates() {
      if (this.getGlobalNotificationData) {
        this.getGlobalNotificationDataResults = this.getGlobalNotificationData.result;
      }
    }
  },
}
</script>

<style lang="scss" scoped>
.notification_info_popup {
  position: fixed;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  z-index: 1001;

  .notification_info_modal {
    background: rgba(0, 0, 0, .96);
    color: #fff;
    min-height: 100%;
    line-height: normal;
    font-size: 20px;
    padding: 15px 30px;
    font-family: -apple-system, BlinkMacSystemFont, Segoe UI, Helvetica Neue, Arial, sans-serif, Apple Color Emoji, Segoe UI Emoji, Segoe UI Symbol, Noto Color Emoji;
    transition: all .7s cubic-bezier(.42,1.14,1,1);
    -webkit-transition: all .7s cubic-bezier(.42,1.14,1,1);
    -moz-transition: all .7s cubic-bezier(.42,1.14,1,1);
    transform: translateX(100%);
    -webkit-transform: translateX(100%);
    -moz-transform: translateX(100%);
    height: 100vh;
    @media only screen and (max-width:767px) {
      padding: 10px 20px;
    }
    &.active{
      -webkit-transform: translateX(0);
      transform: translateX(0);
      overflow: hidden auto;
  }

    .notification_info_modal_header {
      text-align: right;
      padding-bottom: 30px;

      .fa {
        color: #ffe400;
        font-size: 30px;
        cursor: pointer;

        &:hover {
          color: #87cefa;
        }
      }
    }

    .main_heading {
      color: #ffffff;
      font-size: 24px;
      text-transform: uppercase;
      font-weight: bold;
      margin: 0px;
    }

    .btn-primary {
      cursor: pointer;
      position: relative;
      min-width: 95px;
      -webkit-box-shadow: none;
      box-shadow: none;
      outline: none;
      background: rgba(255, 255, 255, 0.12);
      color: #ffffff;
      border: none;
      border-radius: 3px;
      font-family: 'MyriadProRegular', 'Lato', sans-serif;
      font-size: 18px;
      box-shadow: none !important;
      outline: none !important;

      &:hover {
        background: #87cefa;
        color: #000000;
      }

      &.active {
        background: #87cefa;
        color: #000000;
      }

      &.read_all {
        cursor: pointer;
        position: relative;
        min-width: 95px;
        -webkit-box-shadow: none;
        box-shadow: none;
        outline: none;
        background: none;
        color: #ffd400;
        border: 2px solid #ffd400 !important;
        border-radius: 3px;
        font-family: 'MyriadProRegular', 'Lato', sans-serif;
        font-size: 18px;
        line-height: 35px;
        padding: 0px 12px;

        &:hover {
          background: #ffd400;
          color: #000;
        }
      }
    }

    .btn-danger {
      cursor: pointer;
      position: relative;
      min-width: 75px;
      -webkit-box-shadow: none !important;
      box-shadow: none !important;
      background: none;
      color: #ffd400;
      border: 2px solid #ffd400 !important;
      border: none;
      border-radius: 3px;
      font-family: 'MyriadProRegular', 'Lato', sans-serif;
      font-size: 18px;
      line-height: 32px;
      padding: 0px 12px;
      @media only screen and (max-width:767px) {
        font-size: 14px;
        line-height: 1.2;
        padding: 3px 15px;
        min-width: inherit;
        border: 1px solid #ffd400 !important;
      }

      &:hover {
        background: #ffd400;
        color: #000;
        border-color: #ffd400 !important;
      }
    }

    .g_notification_page_wrp {
      color: #fffcc4;

      table {
        width: 100%;
        border-collapse: separate;
        border-spacing: 0 3px;

        tr {
          td {
            color: #ffffff;
            padding: 10px;
            font-size: 20px;
            font-family: 'MyriadProRegular', 'Lato', sans-serif;
            transition: all ease 0.5s;
            -webkit-transition: all ease 0.5s;
            -moz-transition: all ease 0.5s;
            border-top: 0px;
            background: rgba(228, 233, 237, 0.1);
            margin-top: 5px;

            .notifiaction_title {
              font-size: 18px;
              margin: 0px;
            }

            &.notification-invitation {
              color: #90CAF9;
            }

            &.notification-warning {
              color: #FFE082;
            }

            &.notification-danger {
              color: #FFAB91;
            }

            &.notification-reminder {
              color: #CE93D8;
            }

            &.gray_out {
              background: rgba(128, 128, 128, 0.4) !important;
            }

            @media only screen and (max-width:767px) {
              font-size: 16px;
            }
          }

          td:nth-child(2) {
            text-align: right;
          }
        }
      }

      .g_notification_heading {
        font-size: 26px;
        font-weight: 500;
        text-transform: capitalize;
      }

      &.admin_action_section {
        color: #ffbf74;

        table tr td {
          background: rgba(255, 207, 152, 0.16);
          color: #fffcc4;
        }
      }

      &.announcements_section {
        color: #ff907f;

        table tr td {
          background: rgba(255, 179, 168, 0.16);
          color: #fffcc4;
        }
      }

      &.tickets_section {
        color: #FFE082;

        .g_notification_body {
          background: rgba(255, 212, 0, 0.15);
          padding: 5px 10px;

          .btn-primary {
            min-width: 130px;
            padding: 5px;
            background: rgba(22, 255, 121, 0.2);
            color: #fffcc4;

            &:hover {
              background: #87cefa;
              color: #000000;
            }
          }
        }
      }

      &.connections_section {
        color: #9cbef9;

        table tr td {
          background: rgba(135, 179, 255, 0.16);
          color: #fffcc4;
        }
      }

      &.messages_section {
        color: #42e344;

        table tr td {
          background: rgba(122, 255, 124, 0.16);
          color: #fffcc4;
        }
      }

      .notification_date {
        font-size: 16px;
        margin-top: 5px;
        line-height: 1;
        color: #717171;
      }
    }

    .switch_for_status_button {
      display: inline-block;

      .onoffswitch {
        position: relative;
        width: 90px;
        transition: all ease 0.5s;
        -webkit-transition: all ease 0.5s;
        -moz-transition: all ease 0.5s;

        .onoffswitch-checkbox {
          display: none;
        }

        .onoffswitch-label {
          display: block;
          overflow: hidden;
          cursor: pointer;
          border: 0px solid #999999;
          border-radius: 20px;
          margin: 0px;
        }

        .onoffswitch-inner {
          display: block;
          width: 200%;
          margin-left: -100%;
          -webkit-transition: margin 0.3s ease-in 0s;
          transition: margin 0.3s ease-in 0s;

          &::before,
          &::after {
            display: block;
            float: left;
            width: 50%;
            height: 25px;
            padding: 0;
            line-height: 25px;
            font-size: 16px;
            color: white;
            -webkit-box-sizing: border-box;
            box-sizing: border-box;
            font-family: 'MyriadProRegular', 'Lato', sans-serif;
            letter-spacing: 0.5px;
            transition: all ease 0.5s;
            -webkit-transition: all ease 0.5s;
            -moz-transition: all ease 0.5s;
          }

          &::before {
            content: "Read";
            padding-left: 15px;
            background-color: #36B04C;
            color: #FFFFFF;
            text-align: left;
          }

          &::after {
            content: "Unread";
            padding-right: 10px;
            background-color: #6c757d;
            color: #FFFFFF;
            text-align: right;
          }
        }

        .onoffswitch-switch {
          display: block;
          width: 17px;
          height: 17px;
          margin: 4px;
          background: #FFFFFF;
          position: absolute;
          top: 0;
          bottom: 0;
          right: 63px;
          border: 0px solid #999999;
          border-radius: 13px;
          transition: all ease 0.5s;
          -webkit-transition: all ease 0.5s;
          -moz-transition: all ease 0.5s;
        }

        .onoffswitch-checkbox:checked+.onoffswitch-label .onoffswitch-switch {
          right: 0px !important;
        }

        .onoffswitch-checkbox:checked+.onoffswitch-label .onoffswitch-inner {
          margin-left: 0;
        }
      }
    }
  }
    // @media only screen and (max-width: 767px) {
    //    table{
    //     thead{display: none !important;}
    //     tbody{
    //         tr{
    //             display: block !important;
    //             border-bottom: 1px solid rgba(255,255,255,0.1) !important;
    //             padding: 10px 0 !important;
    //             &:last-child{
    //                 border-bottom: none !important;
    //             }
    //             td{
    //                 display: block !important;
    //                 border: none !important;
    //                 padding:1px 5px !important;
    //                 font-size: 16px;
    //             }
    //         }
    //     }
    //    }
    // }
}
</style>